import {StyledOverview} from "@/components/manage/common/overview.styled";
import React from "react";

const Overview = (props) => <StyledOverview {...props}/>;

export default Overview;
